import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { ArrowRight, ArrowLeft, Building2 } from 'lucide-react';
export interface BankDetails {
  accountName: string;
  accountNumber: string;
  sortCode: string;
  bankName: string;
}
interface BankDetailsScreenProps {
  onNext: (details: BankDetails) => void;
  onBack: () => void;
  initialDetails?: BankDetails;
}
export function BankDetailsScreen({
  onNext,
  onBack,
  initialDetails
}: BankDetailsScreenProps) {
  const [details, setDetails] = useState<BankDetails>(initialDetails || {
    accountName: '',
    accountNumber: '',
    sortCode: '',
    bankName: ''
  });
  const isValid = details.accountName && details.accountNumber && details.sortCode && details.bankName;
  return <div className="flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-67">
      <div className="flex-1" data-id="element-68">
        <div className="flex items-center gap-3 mb-2" data-id="element-69">
          <div className="p-2 bg-blue-100 rounded-lg" data-id="element-70">
            <Building2 className="w-6 h-6 text-blue-600" data-id="element-71" />
          </div>
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-72">
            Link Bank Account
          </h2>
        </div>
        <p className="text-gray-600 mb-8 ml-14" data-id="element-73">
          Please provide your business bank account details for settlements.
        </p>

        <div className="grid gap-6 max-w-xl ml-1" data-id="element-74">
          <Input label="Account Holder Name" placeholder="e.g. Acme Corp Sdn Bhd" value={details.accountName} onChange={e => setDetails({
          ...details,
          accountName: e.target.value
        })} data-id="element-75" />

          <Input label="Bank Name" placeholder="e.g. Maybank, CIMB, Public Bank" value={details.bankName} onChange={e => setDetails({
          ...details,
          bankName: e.target.value
        })} data-id="element-76" />

          <div className="grid grid-cols-2 gap-4" data-id="element-77">
            <Input label="Account Number" placeholder="1234567890" value={details.accountNumber} onChange={e => setDetails({
            ...details,
            accountNumber: e.target.value
          })} data-id="element-78" />
            <Input label="Bank Code" placeholder="1234" value={details.sortCode} onChange={e => setDetails({
            ...details,
            sortCode: e.target.value
          })} data-id="element-79" />
          </div>
        </div>
      </div>

      <div className="mt-8 flex justify-between items-center" data-id="element-80">
        <Button variant="secondary" onClick={onBack} data-id="element-81">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-82" /> Back
        </Button>
        <Button onClick={() => isValid && onNext(details)} disabled={!isValid} data-id="element-83">
          Review Application <ArrowRight className="ml-2 h-4 w-4" data-id="element-84" />
        </Button>
      </div>
    </div>;
}